import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
export function Price() {
  const includes = ['5 módulos completos', '5 bonos', 'Acceso inmediato', 'Formato digital', 'Acceso de por vida'];
  return <section id="oferta" className="py-8 md:py-10 px-3 md:px-4 bg-dark" data-id="element-211">
      <div className="max-w-md mx-auto bg-gradient-to-b from-black to-dark border-2 border-terracota rounded-3xl p-6 md:p-8 shadow-[0_0_40px_rgba(201,123,99,0.2)] relative" data-id="element-212">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-terracota text-white font-black px-6 py-1 rounded-full uppercase tracking-wider text-xs md:text-sm whitespace-nowrap" data-id="element-213">
          Oferta Especial
        </div>

        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-6 uppercase" data-id="element-214">
          Todo lo que recibís
        </h2>

        <ul className="space-y-3 mb-6" data-id="element-215">
          {includes.map((item, idx) => <li key={idx} className="flex items-center gap-3 bg-white/5 p-3 rounded-lg" data-id="element-216">
              <div className="bg-rosa/20 p-1 rounded-full shrink-0" data-id="element-217">
                <Check className="text-rosa" size={16} strokeWidth={3} data-id="element-218" />
              </div>
              <span className="text-white font-medium text-sm md:text-base" data-id="element-219">
                {item}
              </span>
            </li>)}
        </ul>

        <div className="text-center mb-6" data-id="element-220">
          <p className="text-gray-500 text-lg line-through font-bold mb-1" data-id="element-221">
            79.990 ARS
          </p>
          <p className="text-4xl md:text-5xl font-black text-terracota drop-shadow-md" data-id="element-222">
            19.990 ARS
          </p>
        </div>

        <Button isCheckout={true} data-id="element-223">QUIERO EMPEZAR HOY</Button>
      </div>
    </section>;
}